import React from "react";
import Navbar from "../../components/Navbar";
import logoLink from "../../assets/img/logo_fluidit.svg";

const Header = () => {
  return <Navbar logoLink={logoLink} />;
};

export default Header;
